import { FC } from 'react';
import { Flex } from '@mantine/core';
import { DrawnSignatureSource } from '@dealstack/shared/lib/common/eideasy/signingMethods';
import { SignDrawBody } from './SignDrawBody';
import { StepBody } from './StepBody';
import { StepFooter } from './StepFooter';
import { StepHeader } from './StepHeader';
import { StepHeading } from './typography';

interface Props {
	onConfirm: (signatureDataUrl: string, source: DrawnSignatureSource) => void;
	onCancel: () => void;
	disableSavedSignature?: boolean;
	hideStepHeader?: boolean;
}

export const SetupSignatureStep: FC<Props> = ({
	onConfirm,
	onCancel,
	disableSavedSignature = false,
	hideStepHeader,
}) => {
	return (
		<Flex direction="column" w="100%" h="100%">
			{!hideStepHeader && <StepHeader onGoBack={onCancel} />}
			<StepBody>
				<StepHeading>Add your signature</StepHeading>
				<SignDrawBody
					onConfirmSignature={onConfirm}
					disableSavedSignature={disableSavedSignature}
				/>
			</StepBody>
			<StepFooter>{null}</StepFooter>
		</Flex>
	);
};
